import { Product } from '../types/product';
import { ProductTransactionSpecifiers } from '../types/productTransaction';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const LIST = '/api/product/list';
const BREAK = '/api/product/break';

export namespace ProductRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<Product>> => {
    return (await http.post(LIST, payload)).data;
  };

  export const breakProduct = async (product: ProductTransactionSpecifiers): Promise<Product[]> => {
    return (await http.post(BREAK, { data: product })).data;
  };
}
